import TableRow from 'components/Shared/Table/TableBodyRow/TableBodyRow'

export default TableRow
